import React from 'react';

const Button = ({ children, onClick, disabled, type, className, title }: {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  title?: string
}) => {
  const defaultStyles = "px-8 py-2 text-white rounded-lg transition duration-200";
  const combinedClassName = `${defaultStyles} ${disabled ? "bg-[#2F99A880] hover:bg-[#2F99A880]" : "bg-[#2F99A8] hover:bg-[#268696]"} ${className || ''}`;
  return (
    <button
      className={combinedClassName}
      onClick={onClick}
      disabled={disabled}
      type={type}
      {...(title ? { title } : {})}
    >
      {children}
    </button>
  );
};

export default Button;